import React from 'react'
import { Link } from 'react-router-dom'

export default function Chili() {
  return <>
    <div className="container-fluid bg-primary py-5 bg-prd5 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Chili Pepper </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Chili Pepper </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Chili Pepper</h2>
        <h5 className='text-muted'> Red pepper is a type of chili characterized by its vibrant red color and its near-conical
          or circular shape. Egyptian chili pepper, also known as Egyptian chili or Egyptian
          hot pepper, is a variety of chili pepper that is native to Egypt. It is known for its spicy
          and intense flavor, making it a popular ingredient in Egyptian cuisine. Egyptian chili
          peppers are typically medium to hot in terms of heat level.
        </h5>
      </div>

      <hr />
    <hr />
    <h2 className='text-primary my-3'>Season:</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>- available all the year 
    </h5>
  </li>


</ul>
<hr />

<h2 className='text-primary my-3'>Packing</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>3 KG, 5 KG carton or according to client request
    </h5>
  </li>
 
</ul>
      <hr />
      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Size:</h5>
        <h5 className=' mt-3'>
          8-12 cm

        </h5>
      </div>
      <hr />
      <hr />
      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
